module.exports = __webpack_public_path__ + "img/st-logo.843a9e2d.svg";